import { MouseEventHandler } from "react";

import threeDots from "./three_dots_icon_dark.png";
import threeDotsHorizontal from "./three_dots_icon_horizontal.png";

type ThreeDotsIconProps = {
  type?: "vertical" | "horizontal";
  onClick?: MouseEventHandler<HTMLDivElement>;
};

const DOTS_IMAGES: Record<"vertical" | "horizontal", string> = {
  vertical: threeDots,
  horizontal: threeDotsHorizontal,
};

export const ThreeDotsIcon = ({ type, onClick }: ThreeDotsIconProps) => {
  return (
    <div onClick={onClick}>
      <img
        src={DOTS_IMAGES[type || "vertical"]}
        style={{ cursor: "pointer" }}
        alt="Three dots icon"
      />
    </div>
  );
};
